const atualizarLocalizacoes = (state, localizacoes) => {
    state.localizacoes = localizacoes;
}

const atualizarLocalizacao = (state, localizacao) => {
    state.localizacao = localizacao;
}

const updateLocalizacao = (state, localizacao) => {
    const item = state.localizacoes.find(item => item.id === localizacao.id);

    Object.assign(item, localizacao);
}

export default {
    atualizarLocalizacoes,
    atualizarLocalizacao,
    updateLocalizacao
}
